<app-breadcrumb></app-breadcrumb>

<section class="mainContent">
  <div class="container">

    @if (searchService.results$ | async; as results) {
      <div class="row">
        @if (results.metadata.totalCount > 0) {
          @for (product of results.result; track product; let i = $index) {
            <div class="col-lg-3 col-md-4">
              <app-search-result [product]="product" [index]="i"></app-search-result>
            </div>
          }
        } @else {
          @if (results.metadata.totalCount === 0) {
            <div class="col-12 not-found-message">
              <h2>No results found for "{{term}}"! <i class="far fa-face-frown"></i></h2>
              <p>Try searching for something else</p>
            </div>
          }
        }
      </div>
    } @else {
      <div class="row loading-message">
        <div style="width: 100%"><i class="fas fa-spinner fa-5x fa-spin"></i></div>
      </div>
    }
  </div>
</section>